module.exports = __webpack_public_path__ + "img/icon-nav-indicators.f28f45db.svg";